import { useMemo } from 'react';

import _ from 'lodash';

import { useDiscountProductsQuery } from 'src/app/queries/discounts/get-discount-products';

import { useDiscountWizardStateContext } from '../state';

import { filterProducts } from './filter-products';
import { getRequirementsFromRequirementStepState } from './helpers';

export function useFilteredProducts({ requirement }: { requirement: number | 'reward' }) {
  const { data: products } = useDiscountProductsQuery();
  const { requirementsStepState, rewardsStepState } = useDiscountWizardStateContext();

  const filters = useMemo(
    () => (requirement === 'reward' ? rewardsStepState.condition.filters : requirementsStepState[requirement].filters),
    [requirement, requirementsStepState, rewardsStepState]
  );

  return useMemo(() => filterProducts({ products, filters }), [products, filters]);
}

export function useAllFilteredProducts() {
  const { data: products } = useDiscountProductsQuery();
  const { requirementsStepState } = useDiscountWizardStateContext();
  const requirements = getRequirementsFromRequirementStepState(requirementsStepState);
  const requirementKeys = Object.keys(requirements);

  const filters = useMemo(
    () => requirementKeys.map((key) => requirementsStepState[Number(key)].filters),
    [requirementKeys, requirementsStepState]
  );

  const filteredProducts = filters.map((filter) => filterProducts({ products, filters: filter }));

  return useMemo(() => _.uniqBy(filteredProducts.flat(), 'InvId'), [filteredProducts]);
}
